import {
  vBoolean,
  vNonEmptyString,
  vObject,
  vOptional,
  vPackingGroup,
  vPipe,
  vPrimaryHazardClass,
  vRegex,
  vString,
  vSubHazardClass,
  vTransform,
} from '../validation/index.ts'
import type { HazardClass, HazardSubClass } from './common.ts'
import type { PackingGroup } from './packing-group.ts'

export interface HazardDetail {
  hazmatId?: string
  permitNumber?: string
  packingGroup?: PackingGroup
  primaryClass?: HazardClass
  secondaryClass?: HazardSubClass
  tertiaryClass?: HazardSubClass
  properShippingName?: string
  technicalName?: string
  reportableQuantity?: boolean
  residueLastContained?: boolean
  limitedQuantity?: boolean
  marinePollutant?: boolean
}

const subClass = vPipe(
  vOptional(vSubHazardClass()),
  vTransform(value => (!value ? undefined : value)),
)

export const loadHazardDetailSchema = vObject({
  hazmatId: vPipe(
    vNonEmptyString(),
    vRegex(/^(NA|UN)\d{4}$/, 'Must match format NA#### or UN####'),
    vTransform(v => (v ? v.toString().toUpperCase() : v)),
  ),
  permitNumber: vOptional(vString()),
  packingGroup: vOptional(vPackingGroup()),
  primaryClass: vOptional(vPrimaryHazardClass()),
  secondaryClass: subClass,
  tertiaryClass: subClass,
  properShippingName: vOptional(vString()),
  technicalName: vOptional(vString()),
  reportableQuantity: vOptional(vBoolean()),
  residueLastContained: vOptional(vBoolean()),
  limitedQuantity: vOptional(vBoolean()),
  marinePollutant: vOptional(vBoolean()),
})
